import { ResultPagDTO } from "@/interfaces/base-dto";
import { IndicadBolsasMedicoFiltrosDTO, IndicadBolsasTipoPacFiltrosDTO, InstituicaoFiltrosDTO, InstituicaoParmDTO } from "@/interfaces/crm-institution";
import { ENDPOINTS } from "@/settings/api-settings";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";

export function getInstitutionClientDetails(id): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_INSTITUTION_CLIENT_DETAILS.replace('{id}', id))).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function getInstitutionProspectDetails(cnpj: string): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_INSTITUTION_PROSPECT_DETAILS.replace('{cnpj}', cnpj.replace(/[^0-9a-zA-Z]/gi, '')))).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listInstitutionQualifications(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_INSTITUTION_QUALIFICATIONS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listInstitutionNpSuppliers(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_INSTITUTION_NP_SUPPLIERS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listInstitutionRtus(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_INSTITUTION_RTUS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listInstitutionPatientTypes(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_INSTITUTION_PATIENT_TYPES)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function saveInstitution(parm: InstituicaoParmDTO): Observable<any> {
  return from(apiClient.post(ENDPOINTS.CRM_INSTITUTION, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function updateInstitution(parm: InstituicaoParmDTO): Observable<any> {
  return from(apiClient.put(ENDPOINTS.CRM_INSTITUTION, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listInstitutionsByFilters(filters: InstituicaoFiltrosDTO): Observable<ResultPagDTO<any>> {
  return from(apiClient.get(ENDPOINTS.CRM_INSTITUTION, filters)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listInstitutionsCombo(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_INSTITUTION_COMBO)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function getInstitutionDetails(id: number): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.CRM_INSTITUTION}/${id}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function updateActivationInstitution(id: number, status: boolean): Observable<any> {
  return from(apiClient.put(ENDPOINTS.CRM_INSTITUTION_ACTIVATION, { id, ativo: status })).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listInstitutionVisitorsCombo(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_INSTITUTION_VISITORS_COMBO)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listInstitutionContactsCombo(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_INSTITUTION_CONTACTS_COMBO)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listInstitutionVisitContactsCombo(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_INSTITUTION_VISIT_CONTACTS_COMBO)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function deleteInstitution(id: number): Observable<any> {
  return from(apiClient.delete(`${ENDPOINTS.CRM_INSTITUTION}/${id}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listInstitutionChartPrescrTpPatient(filter: IndicadBolsasTipoPacFiltrosDTO): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_INSTITUTION_CHART_PRESCR_TP_PATIENT, filter)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function institutionSyncGeoAreas(): Observable<any> {
  return from(apiClient.post(ENDPOINTS.CRM_INSTITUTION_SYNC_GEO_AREAS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listInstitutionChartPrescrDoctors(filter: IndicadBolsasMedicoFiltrosDTO): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_INSTITUTION_CHART_PRESCR_DOCTORS, filter)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}